import store from '../index'
import { httpService } from '@/services/http.service'
import { FunxtionFitnessType, HyroxWorkoutPagination, MssHyrox, WorkoutTypes } from '@/types/workouts'
import { VuexModule, Module, Mutation, Action } from 'vuex-class-modules'
import {MssWorkoutSchedule, ScheduleTypes} from "@/types/schedule";
import {settings} from "@/settings/settings";

@Module
class MssWorkoutsHyroxModule extends VuexModule {
  
  private page = 0
  private readonly perPage = 4
  private workoutsEntries: MssHyrox[] = []
  private _workoutFitnessTypes: FunxtionFitnessType[] = []
  private scheduledworkoutsEntries: MssWorkoutSchedule[] = []

  get workouts() {
    return this.workoutsEntries.filter(workout => workout.type == WorkoutTypes.HYROX)
  }

  get velocityWorkouts() {
    return this.workoutsEntries.filter(workout => workout.type == WorkoutTypes.VELOCITY)
  }

  get scheduledWorkouts() {
    return this.scheduledworkoutsEntries
  }

  get workoutFitnessTypes() { return this._workoutFitnessTypes }

  @Mutation
  private changePage(page: number) {
    this.page = page
  }

  @Mutation
  private setWorkouts(workouts: MssHyrox[]) {
    this.workoutsEntries = workouts.filter((workout, workoutIndex) => {
      const idx = workouts.findIndex(item => workout.id === item.id)
      return idx < 0 || idx == workoutIndex
    })
  }

  @Mutation
  private injectWorkout(workout: MssHyrox) {

    this.workoutsEntries.unshift(workout)
  }

  @Mutation
  removeWorkout(id: string) {
    
    const workoutIdx = this.workoutsEntries.findIndex(workout => workout.id === id)
    
    if (workoutIdx >= 0) {
      this.workoutsEntries.splice(workoutIdx, 1)
    }
  }

  @Mutation
  private setScheduledWorkouts(scheduledWorkouts: MssWorkoutSchedule[]) {
    this.scheduledworkoutsEntries = scheduledWorkouts
  }

  @Mutation
  private setFitnessTypes(types: FunxtionFitnessType[]) {
    this._workoutFitnessTypes = types
  }

  @Action
  async getWorkouts()
  {
    if (this.page == 0) {
      this.changePage(1);
      let response = null;
      let workouts: MssHyrox[] = [];

      do {
        try {
          response = await httpService.mssHyroxWorkouts(this.page, this.perPage) as HyroxWorkoutPagination;
        } catch (err) {
          // eslint-disable-next-line
          console.error(err);
          break;
        }
        workouts = workouts.concat(response.workouts);
        if (response.per_page * response.current_page >= response.total) {
          break;
        }
        this.changePage(this.page + 1);
      } while (response != null &&
      (!response?.cached || this.workouts.length < 1 || response?.total != this.workouts.length) &&
        response.workouts.length > 0
      );
      this.append(workouts);
      this.changePage(0);
    }
  }

  @Action
  async getVelocityWorkouts()
  {
    let page = 1;
    let response = null;
    let workouts: MssHyrox[] = [];

    do {
      try {
        response = await httpService.mssHyroxWorkouts(page, this.perPage, settings.url.mssVelocityWorkouts()) as HyroxWorkoutPagination;
      } catch (err) {
        // eslint-disable-next-line
        console.error(err);
        break;
      }
      workouts = workouts.concat(response.workouts);
      if (response.per_page * response.current_page >= response.total) {
        break;
      }
      page += 1;
    } while (response != null &&
    (!response?.cached || this.workouts.length < 1 || response?.total != this.workouts.length) &&
      response.workouts.length > 0
    );
    this.append(workouts);
  }

  @Action
  async updateWorkout(id: string) {
    let workout = null
    try {
      workout = await httpService.mssHyroxWorkoutById(id) as MssHyrox
    } catch (err) {
      // eslint-disable-next-line no-console
      console.error(err)
      if ((err as any).response && (err as any).response.status === 418) {
        this.removeWorkout(id)
      }
    }

    if (workout != null) {
      this.removeWorkout(id)
      this.injectWorkout(workout)
    }
    return id
  }

  @Action
  async getScheduledWorkouts() {

    const schedule: MssWorkoutSchedule[] = []
    const list = await httpService.scheduledTrainings()
    
    list.filter(item => item.category == ScheduleTypes.HYROX_WORKOUT)
    .forEach(async (item) => {
      let workout
      do {
        workout = this.workouts.find(workout => workout.uuid == item.id)
        if (workout == undefined) {
          await this.updateWorkout(item.id)
        } else {
          const { category, tsf, rtf } = item
          schedule.push({
            ID: workout.id,
            category,
            workout,
            starttime: rtf,
            startTs: tsf/1000,
            multi: false
          } as MssWorkoutSchedule)
        }
      } while (workout == undefined)
    })
    this.setScheduledWorkouts(schedule)
  }

  @Action
  async getFitnessTypes() {
    this.setFitnessTypes(await httpService.hyroxworkoutFitnessTypes())
  }

  @Action
  async append(workouts: MssHyrox[])
  {
    this.setWorkouts(this.workoutsEntries.concat(workouts));
  }

  @Action
  async initialize() {
    this.setWorkouts([])
    await Promise.all([
      this.getWorkouts(),
      this.getVelocityWorkouts(),
      this.getScheduledWorkouts(),
      this.getFitnessTypes()
    ])
  }

  @Action
  resetToDefault() {
    this.changePage(0)
    this.setWorkouts([])
  }
}

export const mssWorkoutsHyroxModule = new MssWorkoutsHyroxModule({ store, name: 'mssWorkoutsHyrox' })